import { Component } from 'react';
import EditEventDialog from './UI/EditEventDialog';
import CalendarWidgetPainter from './CalendarWidgetPainter';
import CoreComponent from '../services/engines/CoreComponent';

/**
 * CalendarWidget — renders floating cards, upcoming drawer and the edit dialog.
 * EditEventDialog is a sibling, not nested — it has its own pub/sub via
 * useCalEventEdit and does not need to repaint when CalendarWidgetPainter does.
 * Engine bootup happens globally in PageContent — this component is a pure painter.
 */
export default class CalendarWidget extends CoreComponent {
    _name = 'CalendarWidget';

    componentDidMount() {
        this.logDebug(`ComponentDidMount`, 'Enter');
    }

    componentWillUnmount() {
        this.logDebug(`ComponentWillUnmount`, 'Enter');
    }

    render() {
        return (
            <>
                {/* CalendarWidget — renders floating cards, upcoming drawer and the edit dialog. */}
                <CalendarWidgetPainter />

                {/* EditEventDialog is a sibling, not nested — it has its own pub/sub via */}
                <EditEventDialog />
            </>
        );
    }
}
